import * as util from '../base/util';
import TaskRunner from '../base/TaskRunner';

TaskRunner.add(() => {
    let classList = util.rootElem().classList;

    if (util.isTouch()) classList.add('touch-device');
    if (util.isIe()) classList.add('is-ie');
    if (util.isSafari()) classList.add('is-safari');

    document.body.classList.remove('preload');
});